module.exports = __webpack_public_path__ + "img/Art07-20110073-003.047a3700.jpg";